import React from "react";
import Select, { components as RSComponents } from "react-select";
import { countriesList, phoneAuthSelectStyles } from "../../utils/CountriesList";

function PhoneCountrySingleValue(props) {
  const { data } = props;
  const flag =
    typeof data.label === "string" ? data.label.trim().split(/\s+/)[0] || "" : "";
  return (
    <RSComponents.SingleValue {...props}>
      <span className="auth-phone-country-inner">
        <span className="auth-phone-country-flag" aria-hidden>
          {flag}
        </span>
        <span className="auth-phone-country-code">{data.value}</span>
      </span>
    </RSComponents.SingleValue>
  );
}

function PhoneCountryDropdownIndicator(props) {
  return (
    <RSComponents.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-fill" aria-hidden="true" />
    </RSComponents.DropdownIndicator>
  );
}

/**
 * Single-row phone field: country (flag + dial code) | divider | number — matches signup/login reference UI.
 */
export default function AuthPhoneField({
  countryCode,
  onCountryChange,
  phone,
  onPhoneChange,
  inputId = "authPhoneCountry",
  phonePlaceholder = "Enter phone number",
  readOnly = false,
  wrapClassName = "",
  selectProps = {},
}) {
  const portalTarget = typeof document !== "undefined" ? document.body : null;
  const rootClass = ["auth-phone-field", "auth-phone-field--unified", wrapClassName].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <div className="auth-phone-field__country">
        <Select
          inputId={inputId}
          name="country_code_select"
          classNamePrefix="auth-phone-country"
          options={countriesList}
          onChange={(selected) => onCountryChange(selected?.value)}
          value={countriesList.find((option) => option.value === countryCode)}
          styles={phoneAuthSelectStyles}
          components={{
            SingleValue: PhoneCountrySingleValue,
            DropdownIndicator: PhoneCountryDropdownIndicator,
            IndicatorSeparator: null,
          }}
          menuPortalTarget={portalTarget}
          menuPosition="fixed"
          isSearchable
          blurInputOnSelect
          isClearable={false}
          {...selectProps}
        />
      </div>
      <div className="auth-phone-field__divider" aria-hidden="true" />
      <div className="auth-phone-field__number">
        <input
          className="input_filed auth-phone-field__input"
          type="text"
          inputMode="numeric"
          placeholder={phonePlaceholder}
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value.replace(/\D/g, ""))}
          autoComplete="tel"
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}
